<template>
    <div class="contact-form">
        <h2>Contacte-nos</h2>
        <h4>Nome</h4>
        <input class="one-liner" v-bind:style="{ 'background-color': style.inputBackground}" v-model="form.name" placeholder="Nome">
        <span>{{this.errors.name}}</span>
        <h4>Email</h4>
        <input class="one-liner" v-bind:style="{ 'background-color': style.inputBackground}" v-model="form.email" placeholder="Email">
        <span>{{this.errors.email}}</span>
        <h4>Assunto</h4>
        <input class="one-liner" v-bind:style="{ 'background-color': style.inputBackground}" v-model="form.subject" placeholder="Assunto">
        <span>{{this.errors.subject}}</span>
        <h4>Mensagem</h4>
        <textarea class="multi-liner" v-bind:style="{ 'background-color': style.inputBackground}" v-model="form.message" placeholder="Mensagem"/>
        <span>{{this.errors.message}}</span>
        <div class="row start-xs">
            <div class="col-xs-3 button-col">
                <button v-on:click="sendFormData()">Enviar</button>
            </div>
            <div class="col-xs-9 submit-info" v-if="submited">
                <span>Obrigado por ter submetido a sua mensagem.</span><br/>
                <span>Responderemos o mais breve possível.</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {sendFormData} from "../../services/email.service";
    import * as inputHelper from "../../helpers/input.helper";

    export default {
        name: "ContactForm",
        props: {
            inputBackground: {
                type: String,
                default: '#F5F5F5'
            },
            subject: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    subject: this.subject,
                    message: ''
                },
                errors: {
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                },
                style: {
                    inputBackground: this.inputBackground
                },
                showErrors: false,
                submited: false
            }
        },
        methods: {
            sendFormData() {
                if (this.checkFormData()) {
                    this.showErrors = false;
                    sendFormData('cota8086', this.form.name, this.form.email, this.form.subject, this.form.message)
                        .then(() => {
                            this.submited = true;
                        });
                } else {
                    this.showErrors = true;
                }
            },
            checkFormData() {
                let errors = false;

                if (this.form.name.length < 1) {
                    this.errors.name = 'Este campo é obrigatório!';
                    errors = true;
                } else {
                    this.errors.name = '';
                }

                if (!inputHelper.emailVerification(this.form.email)) {
                    this.errors.email = 'Email inválido!';
                    errors = true;
                } else {
                    this.errors.email = '';
                }

                if (this.form.subject.length < 1) {
                    this.errors.subject = 'Este campo é obrigatório!';
                    errors = true;
                } else {
                    this.errors.subject = '';
                }

                if (this.form.message.length < 1) {
                    this.errors.message = 'Este campo é obrigatório!';
                    errors = true;
                } else {
                    this.errors.message = '';
                }

                return !errors;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .contact-form {
        text-align: left;

        span {
            text-transform: uppercase;
            letter-spacing: 0.1em;
            font-weight: 500;
            font-family: inherit;
            font-size: xx-small;
            color: #ff6500;
        }
    }

    .button-col {
        margin-top: 1em;
        padding-right: 0;
        padding-left: 0;

        button {
            height: 3.5em;
            border: 0;
            width: 100%;
            background: $primary;
            color: $bgcolor-grey;
            text-transform: uppercase;
            font-size: x-small;
            letter-spacing: 0.1em;
            font-weight: 600;

            &:hover {
                 background: $bgcolor-grey;
                 color: $primary;
             }
        }
    }

    .submit-info {
        margin-top: 0.8em;
        padding-right: 3em;
        padding-left: 3em;
        span {
            color: $primary !important;
        }
    }

    input.one-liner {
        border: hidden;
        background-color: $bgcolor-grey;
        height: 2em;
        width: 100%;
        font-family: 'Work Sans', sans-serif;
    }

    textarea.multi-liner {
        border: hidden;
        background-color: $bgcolor-grey;
        height: 6em;
        width: 100%;
        font-family: 'Work Sans', sans-serif;
    }

    .placeholder {
        text-transform: uppercase;
        font-size: smaller;
        letter-spacing: 0.1em;
        font-weight: 500;
        font-family: inherit;
    }

    ::placeholder {
        text-transform: uppercase;
        font-size: smaller;
        letter-spacing: 0.1em;
        font-weight: 500;
        font-family: inherit;
    }

    ::-ms-input-placeholder {
        text-transform: uppercase;
        font-size: smaller;
        letter-spacing: 0.1em;
        font-weight: 500;
        font-family: inherit;
    }

    textarea::-webkit-input-placeholder {
        text-transform: uppercase;
        font-size: small;
        letter-spacing: 0.2em;
        font-weight: 500;
        font-family: inherit;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
        text-transform: uppercase;
        font-size: small;
        letter-spacing: 0.2em;
        font-weight: 500;
        font-family: inherit;
    }

    textarea::-moz-placeholder {  /* Firefox 19+ */
        text-transform: uppercase;
        font-size: small;
        letter-spacing: 0.2em;
        font-weight: 500;
        font-family: inherit;
    }

    textarea:-ms-input-placeholder {
        text-transform: uppercase;
        font-size: small;
        letter-spacing: 0.2em;
        font-weight: 500;
        font-family: inherit;
    }

    textarea::placeholder {
        text-transform: uppercase;
        font-size: small;
        letter-spacing: 0.2em;
        font-weight: 500;
        font-family: inherit;
    }

</style>
